module.exports = __webpack_public_path__ + "static/media/del-sol-login.15c7a47f.svg";